// designer-model.js

import ControlModel            from 'ControlModel.js';

class GroupModel extends ControlModel {

    getMapReviver(){

        const childList = this.get('childList');
        return (key, value) => {
            var serializedValue = value;

            switch(key){
                case 'childList':
                    serializedValue = childList;
                    break;
                case 'mandatories':
                case 'state':
                    serializedValue = new Map(value);
                    break;
            }

            return serializedValue;
        };

    }

}

export default GroupModel;
